export class CalculatedDimension {
  isEquals(other) {  // eslint-disable-line
    return false;
  }

  isNeedUpdate(parentDimension) { // eslint-disable-line
    return false;
  }

  calcValue(parentDimension) { // eslint-disable-line
    return 0;
  }

  copy() {
    return undefined;
  }
}
